"use strict";

exports.__esModule = true;

require('./list.css');

exports.default = {
  "list": "pf-c-list",
  "modifiers": {
    "inline": "pf-m-inline"
  }
};